import { connect } from 'react-redux';
import { updateTcAccepted } from 'ducks/auth';
import TermsAndConditions from './TermsAndConditions';

const mapStateToProps = (state) => ({
  hasAcceptedTC: state.auth.hasAcceptedTC,
  userId: state.auth.userId,
});

const mapDispatchToProps = {
  updateTcAccepted,
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions);
